module.exports = __webpack_public_path__ + "static/img/DSC_2655.0063bab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2655.jpg
// module id = 267
// module chunks = 0